import React from 'react';
import './TopUpPurpose.scss';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import { useDispatch } from 'react-redux';
import { appSlice } from '../../../../store/slices';
import { t } from '../../../../lang';
import { useIntl } from 'react-intl';

export const TopUpPurpose = ({ comment = '', approvalFiles, showFiles }) => {
	const intl = useIntl();
	const dispatch = useDispatch();

	const handleOpenModal = () => {
		if (!showFiles) return;
		dispatch(
			appSlice.actions.addModal({
				isHeaderWithColorBgAndIcon: true,
				title: intl.formatMessage({ id: 'Attached files' }),
				subtitle: intl.formatMessage({ id: 'Files attached to this payment' }),
				headerBackgroundColor: '#0455A3',
				headerIcon: 'DOCUMENT_FILL',
				tag: 'ShowFilesModal',
				isOpen: true,
				height: '60%',
				outsideParams: { approvalFiles },
			})
		);
	};

	return (
		<div className='topUp-purpose'>
			<div className='topUp-purpose__section'>
				<div className='topUp-purpose__label'>{t('Payment purpose')}</div>
				{comment && <div className='topUp-purpose__value'>{comment}</div>}
			</div>

			{approvalFiles?.length > 0 && (
				<>
					<div className='topUp-purpose__divider' />

					<div className='topUp-purpose__row' onClick={handleOpenModal}>
						<div className='topUp-purpose__row-text'>{t('Attached files')}</div>
						<div className='topUp-purpose__row-count'>
							{approvalFiles?.length}

							{showFiles && (
								<Icon
									className='topUp-purpose__row-icon'
									type={Icons.ARROW_CHEVRON}
									width={16}
									height={16}
								/>
							)}
						</div>
					</div>
				</>
			)}
		</div>
	);
};
